<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>组织生活</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="treeWrap" v-if="$store.state.user.userinfo.flag!=3">
				<tree @treeSelect="treeSelect"></tree>
			</div>
			<div class="datatable">
				<div class="datas">
					<div class="counts">
						<div class="count">活动次数：<span>{{all_count}}</span>次</div>
						<div class="count">集中学习：<span>{{focus_count}}</span>次</div>
						<div class="count">学习课时：<span>{{hours_count}}</span>课时</div>
					</div>
					<div class="switchBar">
						<span :class="{selectSwitch:getdata.status == 2}" @click="getdata.status = 2;dataList();getdata.page=1">已完成</span>
						<span :class="{selectSwitch:getdata.status == 1}" @click="getdata.status = 1;dataList();getdata.page=1">未开始</span>
					</div>
					<div class="selectbar">
						<div style="display: flex;align-items: center;">
							<div class="inputs" style="width: 150px;margin-right: 10px;">
								<el-select
									size="small"
									v-model="getdata.type" placeholder="活动类型"
									@change="getdata.page = 1;totalPage = 0;dataList();"
									clearable>
									<el-option
										:key="index"
										v-for="(item,index) in typeList"
										:label="item.type"
										:value="item.id">
									</el-option>
								</el-select>
							</div>
							<div class="inputs" style="width: 100px !important;margin-right: 10px;">
								<el-select
									size="small"
									v-model="getdata.year" placeholder="选择年份"
									@change="getdata.page = 1;totalPage = 0;dataList();"
									clearable>
									<el-option
										:key="index"
										v-for="(item,index) in $yearList()"
										:label="item"
										:value="item">
									</el-option>
								</el-select>
							</div>
							<div style="width: 100px !important;">
								<el-select
									size="small"
									v-model="getdata.month" placeholder="选择月份"
									@change="getdata.page = 1;totalPage = 0;dataList();"
									clearable>
									<el-option
										:key="index"
										v-for="(item,index) in $monthList()"
										:label="item+'月'"
										:value="item">
									</el-option>
								</el-select>
							</div>
						</div>
						<div>
							<el-switch
							style="margin-right: 15px;"
								:inactive-value="2"
								:active-value="1"
								inactive-text="集中学习"
								@change="getdata.page = 1;totalPage = 0;dataList();"
								v-model="getdata.focus">
							</el-switch>
							<el-button type="primary" size="small" @click="onekey">一键签到</el-button>
							<el-button type="primary" size="small" @click="delAll">一键删除</el-button>
							<el-button type="primary" size="small" @click="goAdd">新增</el-button>
						</div>
					</div>
					<div class="selectdata">
						<myTables 
							@selectEnable="selectEnable"
							:tableData="tableData"
							delkey=""
							@selectList="selectList"
							:tableHeader="tableHeader"
							:loading="true" 
							:indexs="false"
							:selection="true"></myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import indexs from './mixins/index'
	export default{
		mixins: [indexs],
	}
</script>

<style lang="scss" scoped="scoped">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian {
		    height: 86px;
		    width: 150px;
			object-fit: cover;
		}
		.switchBar{
			width: 100%;
			height: 40px;
			line-height: 40px;
			margin-bottom: 20px;
			border-bottom: 1px solid #DDDDDD;
			span{
				cursor: pointer;
				display: inline-block;
				line-height: 40px;
				font-size: 16px;
				margin-right: 20px;
				padding: 0 20px;
				font-weight: bold;
			}
			span:hover{
				color: #BB0000;
				border-bottom: 2px solid #bb0000;
			}
			.selectSwitch{
				color: #BB0000;
				border-bottom: 2px solid #bb0000;
			}
		}
	}
	.counts{
		display: flex;
		width: 100%;
		align-items: center;
		font-size: 14px;
		color: #1E2129;
		.count{
			margin-right: 70px;
			span{
				font-size: 36px;
				color: #1266E3;
				font-weight: bold;
			}
		}
	}
</style>

